import axios from 'axios'
import { ai_api } from './variables'

// Fetch all conversations for the authenticated user
export const fetchConversations = async () => {
  try {
    const response = await axios.get(`${ai_api}/chat/conversations/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    return response.data
  } catch (error) {
    console.error('Failed to fetch conversations:', error)
    throw error
  }
}

// Create a new conversation (optional - for future use)
export const createConversation = async (title) => {
  try {
    const response = await axios.post(`${ai_api}/chat/conversations/`,
      { title },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response.data
  } catch (error) {
    console.error('Failed to create conversation:', error)
    throw error
  }
}

// Delete a conversation
export const deleteConversation = async (conversationId) => {
  try {
    const response = await axios.post(`${ai_api}/chat/conversations/delete/`,
      { conversation_id: conversationId },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response.data
  } catch (error) {
    console.error('Failed to delete conversation:', error)
    throw error
  }
}
